import React, { useState } from 'react';
import styles from './ContactPage.module.css';

export default function ContactPage() {
  const [copied, setCopied] = useState(false);

  const copyEmail = () => {
    navigator.clipboard.writeText('admin@codewithneo.com').then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  };

  return (
    <div className={styles.page}>
      <section className={styles.hero}>
        <div className={styles.heroIcon}>✉️</div>
        <h1 className={styles.heroTitle}>Contact Us</h1>
        <p className={styles.heroSub}>
          Have a feature request, found a bug, or want to contribute?<br />
          We'd love to hear from you.
        </p>
      </section>

      <div className={styles.grid}>
        {/* EMAIL CARD */}
        <div className={styles.card}>
          <div className={styles.cardIcon}>📧</div>
          <h2 className={styles.cardTitle}>Email</h2>
          <p className={styles.cardDesc}>
            Reach the admin team directly via email. We respond within 48 hours on business days.
          </p>
          <div className={styles.emailBox}>
            <span className={styles.emailText}>admin@codewithneo.com</span>
            <button className={styles.copyBtn} onClick={copyEmail}>
              {copied ? '✓ Copied!' : '📋 Copy'}
            </button>
          </div>
          <a
            href="mailto:admin@codewithneo.com?subject=HARScope%20Feedback"
            className={styles.mailtoBtn}
          >
            Open in Mail Client →
          </a>
        </div>

        {/* WHAT TO SEND */}
        <div className={styles.card}>
          <div className={styles.cardIcon}>📝</div>
          <h2 className={styles.cardTitle}>What to Include</h2>
          <ul className={styles.list}>
            <li><span>🐛</span><div><strong>Bug reports:</strong> Browser name + version, steps to reproduce, and what you expected vs. what happened.</div></li>
            <li><span>💡</span><div><strong>Feature requests:</strong> Describe your use case and what problem it would solve.</div></li>
            <li><span>🔒</span><div><strong>Security issues:</strong> Please disclose responsibly via email rather than public issues.</div></li>
            <li><span>🤝</span><div><strong>Contributions:</strong> Let us know what you'd like to build and we'll discuss the roadmap.</div></li>
          </ul>
        </div>

        {/* RESPONSE TIME */}
        <div className={styles.card}>
          <div className={styles.cardIcon}>⏱️</div>
          <h2 className={styles.cardTitle}>Response Times</h2>
          <div className={styles.rtGrid}>
            <div className={styles.rtItem}>
              <div className={styles.rtType}>Bug Reports</div>
              <div className={styles.rtTime} style={{ color: 'var(--accent3)' }}>24–48 hrs</div>
            </div>
            <div className={styles.rtItem}>
              <div className={styles.rtType}>Feature Requests</div>
              <div className={styles.rtTime} style={{ color: 'var(--accent)' }}>3–5 days</div>
            </div>
            <div className={styles.rtItem}>
              <div className={styles.rtType}>Security Issues</div>
              <div className={styles.rtTime} style={{ color: 'var(--warn)' }}>24 hrs</div>
            </div>
            <div className={styles.rtItem}>
              <div className={styles.rtType}>General Enquiries</div>
              <div className={styles.rtTime} style={{ color: 'var(--text2)' }}>5–7 days</div>
            </div>
          </div>
        </div>

        {/* PRIVACY NOTE */}
        <div className={`${styles.card} ${styles.cardPrivacy}`}>
          <div className={styles.cardIcon}>🔒</div>
          <h2 className={styles.cardTitle}>A note on privacy</h2>
          <p className={styles.cardDesc}>
            HARScope is a client-side only tool. We do not collect, store, or process any HAR files or
            network data. When you contact us, please do <strong>not</strong> include sensitive HAR file
            contents in your email. If you need to share a HAR file to reproduce a bug, please redact
            sensitive headers (Authorization, Cookie, etc.) first.
          </p>
        </div>
      </div>
    </div>
  );
}
